var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('full-calendar',_vm._b({ref:"fullCalendar",attrs:{"id":"fullCalendar","events":_vm.events,"contentHeight":"auto"},on:{"select":_vm.onSelect}},'full-calendar',_vm.calendarOptions,false))],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }